import { Component, Input, Output, EventEmitter } from "@angular/core";
import { JoiTemplate, ColorTemplateNames, ColorTemplate } from "globals/store/publish.data";
import { CommonModule } from "@angular/common";
import { ColorPickerComponent } from "./color-picker.component";
import { HexIsLightPipe } from "src/app/services/pipes/lightHex.pipe";

@Component({
    selector: 'color-selector',
    template: `
<ng-container *ngIf="!tinyMode">
  <div class="dot" 
    [style.background-color]="color" 
    [ngClass]="{ outline: color | hexIsLight, interactive: !readOnly }" 
    (click)="open.emit()"></div>
  <h5>{{ ColorTemplateNames[key] }}</h5>
  <div class="hex">{{ color }}</div>
</ng-container>
<div class="tiny" *ngIf="tinyMode" (click)="pickerOpen=true">
  <div class="dot small" *ngIf="tinyMode" 
    [style.background-color]="color" 
    [ngClass]="{ outline: color | hexIsLight, interactive: !readOnly }" 
  ></div>
  <div class="hex">{{ color }}</div>
</div>
<color-picker *ngIf="!readOnly && !!pickerOpen" [color]="color" (changeColor)="pickerOpen = false; changeColor.emit($event)"></color-picker>
`,
    styles: [`
:host { display: flex; flex-direction: column; align-items: center; width: fit-content; position: relative; }
.dot { height: 36px; width: 36px; border-radius: 50%; display: inline-block; }
.dot.small { height: 18px; width: 18px; }
.tiny { display: flex; align-items: center; }
.tiny .hex { margin: 0 0 0 10px; }
.dot.interactive { cursor: pointer; }
.dot.outline { border: 1px solid #aaa; }
h5 { margin-top: 10px; }
.hex { margin-top: 5px; font-size: 11px; }
color-picker { position: absolute; top: -250px; z-index: 1000; }
`],
    standalone: true,
    imports: [CommonModule, ColorPickerComponent, HexIsLightPipe]
})
export class ColorSelectorComponent {
  @Input() key: keyof ColorTemplate
  @Input() color: string
  @Input() readOnly: boolean
  @Input() pickerOpen = false
  @Input() tinyMode = false
  @Output() open: EventEmitter<null> = new EventEmitter()
  @Output() changeColor: EventEmitter<string> = new EventEmitter()

  ColorTemplateNames = ColorTemplateNames

}
